import { render, staticRenderFns } from "./BeneficiarioHeader.vue?vue&type=template&id=1bcc43aa&"
import script from "./BeneficiarioHeader.vue?vue&type=script&lang=js&"
export * from "./BeneficiarioHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports